module.exports = __webpack_public_path__ + "DiplomainGameDevelopmentwithUnity-66a4338c.webp";